export const idGenerator = (): number => {
	const array: Uint32Array = new Uint32Array(2);
	globalThis.crypto.getRandomValues(array);

	const high = typeof array[0] === "number" ? array[0] : 0;
	const low = typeof array[1] === "number" ? array[1] : 0;

	return (high & 2_097_151) * 1_000_000 * 4294.967_296 + low;
};
